import { useMemo } from 'react';
import { Box, SystemStyleObject } from '@chakra-ui/react';
import { CompanyChip } from 'components/elements/Chips/CompanyChip';
import { FlexRow } from 'components/layout/FlexRow';
import { CompanyItem } from 'types';

const containerStyle = {
  width: '100%',
  columnGap: (theme: any) => theme.space[2],
  justifyContent: 'flex-start',
};

const overflowNumStyle = {
  color: 'brand.black',
  fontSize: '12px',
};

type Props = {
  companyList: CompanyItem[];
  showLink?: boolean;
  showEmptyState?: boolean;
  maxCompaniesToShow?: number;
  sx?: SystemStyleObject;
};

export const CompanyInformation = ({
  companyList,
  showLink = true,
  showEmptyState = true,
  maxCompaniesToShow = 5,
  sx = {},
}: Props) => {
  const sortedCompanies = useMemo(() => {
    const sortedList = [...companyList];

    return sortedList.slice(0, maxCompaniesToShow);
  }, [companyList, maxCompaniesToShow]);

  const numOverflowCompanies = useMemo(
    () => companyList.length - maxCompaniesToShow,
    [companyList.length, maxCompaniesToShow],
  );

  const isInvalidCompanyList = !companyList || companyList.length === 0;

  if (isInvalidCompanyList) {
    return null;
  }

  return (
    <FlexRow sx={{ ...containerStyle, ...sx }}>
      {sortedCompanies.map((company: CompanyItem) => (
        <CompanyChip
          key={`company-chip-${company.uuid}-${company.name}`}
          id={company.uuid}
          name={company.name}
          showLink={showLink}
          showEmptyState={showEmptyState}
          displayIcon
        />
      ))}
      {numOverflowCompanies > 0 && (
        <Box sx={overflowNumStyle}>{`+${numOverflowCompanies}`}</Box>
      )}
    </FlexRow>
  );
};

export default CompanyInformation;
